import type { ProductPreview } from 'models/purchaseFlowRevamp'
import type { ProductThumbnailV2 } from 'models/purchaseFlowRevamp/catalogueV2DTO'

/**
 * The card preview for a wire thumbnail, or undefined when there is none — the
 * card then renders the designed placeholder tile.
 *
 * The kinds map one to one onto `ProductPreview`.
 *
 * @example
 * previewFromThumbnail({ kind: 'image', imageUrl: 'https://…/a.jpg' })
 * // → { kind: 'image', imageUrl: 'https://…/a.jpg' }
 */
export const previewFromThumbnail = (
  thumbnail: ProductThumbnailV2 | null | undefined
): ProductPreview | undefined => {
  if (!thumbnail) return undefined
  return {
    kind: thumbnail.kind,
    imageUrl: thumbnail.imageUrl,
    videoUrl: thumbnail.videoUrl,
    beforeImageUrl: thumbnail.beforeImageUrl,
    afterImageUrl: thumbnail.afterImageUrl,
  }
}
